
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {CoachPlayersProfileDiagnosticsListIndex} from "@/models/app/coach/players/profile/diagnostics/list/index";
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import CoachPlayersProfileDiagnosticsListFormCreateIndexVue from "@/views/app/coach/players/profile/diagnostics/list/form/create.vue";
import CoachPlayersProfileDiagnosticsListFormUpdateIndexVue from "@/views/app/coach/players/profile/diagnostics/list/form/update.vue";
import CoachPlayersProfileDiagnosticsListFormRemoveIndexVue from "@/views/app/coach/players/profile/diagnostics/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "diagnosticCategories",
  ],
  components: {
    ElRow,
    ElCol,
    CoachPlayersProfileDiagnosticsListFormCreateIndexVue,
    CoachPlayersProfileDiagnosticsListFormUpdateIndexVue,
    CoachPlayersProfileDiagnosticsListFormRemoveIndexVue,
  },
})
export default class CoachPlayersProfileDiagnosticsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: "*",
      diagnostic_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  diagnostics: Array<CoachPlayersProfileDiagnosticsListIndex> = [];

  async getDiagnostics(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/diagnostics`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.diagnostics = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    this.formData.filter.user_id = this.$route.params.id;
    await this.getDiagnostics();
  }
}
